import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getUsers } from '../api';
import { Avatar, PageHeader, Spinner, EmptyState } from '../components/UI';

export default function PeopleSearchPage() {
  const [allUsers, setAllUsers] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getUsers()
      .then(data => {
        const sorted = [...data].sort((a, b) => a.username.localeCompare(b.username));
        setAllUsers(sorted);
        setFiltered(sorted);
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    const q = search.toLowerCase().trim();
    setFiltered(
      allUsers.filter(u => !q || u.username?.toLowerCase().includes(q))
    );
  }, [search, allUsers]);

  return (
    <div className="page-container">
      <PageHeader title="Find Golfers" subtitle="Search by username to view their scores" />

      <div className="relative mb-5">
        <span className="absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400 text-sm"></span>
        <input
          type="text"
          className="input-field pl-9"
          placeholder="👤 Search by username..."
          value={search}
          onChange={e => setSearch(e.target.value)}
          autoFocus
        />
        {search && (
          <button
            onClick={() => setSearch('')}
            className="absolute right-3.5 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 text-sm"
          >
            ✕
          </button>
        )}
      </div>

      {loading ? (
        <div className="flex justify-center py-16"><Spinner size="lg" /></div>
      ) : filtered.length === 0 ? (
        <EmptyState
          icon="🔍"
          title={search ? 'No users found' : 'No golfers yet'}
          message={search ? `No one with username matching "${search}".` : 'Be the first to sign up!'}
        />
      ) : (
        <div className="space-y-2">
          {filtered.map(u => (
            <Link
              key={u.id}
              to={`/profile/${u.id}`}
              className="card p-4 flex items-center gap-4 hover:bg-amber-50/60 transition-colors block"
            >
              <Avatar url={u.avatar_url} username={u.username} />
              <div className="flex-1 min-w-0">
                <div className="font-medium text-green-900">{u.username}</div>
                {u.handicap != null && (
                  <div className="text-xs text-gray-400">Handicap: {u.handicap}</div>
                )}
              </div>
              <span className="text-green-600 text-sm">→</span>
            </Link>
          ))}
        </div>
      )}

      {allUsers.length > 0 && (
        <p className="text-center text-xs text-gray-400 mt-5">
          {filtered.length} of {allUsers.length} golfer{allUsers.length !== 1 ? 's' : ''}
        </p>
      )}
    </div>
  );
}
